import { Dominios, StatusCode } from "../../../utils/enums";
import { getEsMutuoRecaudable, getFormasPago, getMutuoDeshacerRecaudacion, getMutuoRecaudar, getParametroByCodigo, getRecalcularMontos, getRecaudadores, postContabilizarRecaudacion, postMutuoRecaudar, postMutuoDeshacerRecaudacion } from "../services/servicesRecaudacionIndividual";
import { DataContabilizacionRecaudacionDividendoToSubmit, DataRecaudacionToSubmit, MontosRecalculadosDto, ParametrosRecalculo, RecaudacionReadDto, RecaudacionReversarReadDto } from "../models/mutuoRecaudar";
import { Recaudador } from "../models/recaudador";
import { Parametro } from "../models/parametro";
import { selectorTransversal } from "../../../dtos/selector";
import { useToast } from "../../../hooks/useToast";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { AxiosResponse } from "axios";

export function useRecaudacionIndividual() {

    const { addToast } = useToast();
    
    const obtenerMutuoRecaudar = async (mutuoId: number): Promise<RecaudacionReadDto | void> => {
        const resp = await getMutuoRecaudar(mutuoId);
        return resp.status === StatusCode.Ok ? await resp.data : undefined;
    }

    const obtenerMutuoDeshacerRecaudacion = async (mutuoId: number): Promise<RecaudacionReversarReadDto | void> => {
        const resp = await getMutuoDeshacerRecaudacion(mutuoId);
        return resp.status === StatusCode.Ok ? await resp.data : undefined;
    }

    const recaudarDividendo = async (dataRecaudacion: DataRecaudacionToSubmit) : Promise<void> => {
        const resp = await postMutuoRecaudar(dataRecaudacion);

        if (resp.status !== StatusCode.Ok)
            throw new Error(resp.data.message);
    }

    const deshacerRecaudacionDividendo = async (mutuoId: number, numeroDividendo: number) : Promise<void> => {
        const resp = await postMutuoDeshacerRecaudacion(mutuoId, numeroDividendo);

        if (resp.status !== StatusCode.Ok)
            throw new Error(resp.data.message);
    }

    const contablizarOperacion = async (dataContabilizacion: DataContabilizacionRecaudacionDividendoToSubmit) : Promise<void> => {
        const resp = await postContabilizarRecaudacion(dataContabilizacion);

        if (resp.status !== StatusCode.Ok)
            throw new Error(resp.data.message);
    }

    const obtenerRecaudadores = async (): Promise<Recaudador[]> => {
        const resp : AxiosResponse<ListResponseDto<Recaudador>>= await getRecaudadores();
        return resp.status === StatusCode.Ok ? await resp.data.items : [];
    }

    const recalcularMontos = async (parametrosRecalcular: ParametrosRecalculo): Promise<MontosRecalculadosDto | void> => {
        const resp = await getRecalcularMontos(parametrosRecalcular);
        return resp.status === StatusCode.Ok ? await resp.data : undefined;
    }

    const obtenerParametroByCodigo = async (codigo: string): Promise<Parametro | void> => {
        const resp = await getParametroByCodigo(codigo);
        return resp.status === StatusCode.Ok ? await resp.data : undefined;
    }

    const obtenerFormasPago = async (): Promise<selectorTransversal[]> => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getFormasPago(Dominios.RECAUDACION_FORMA_PAGO);
        return resp.status === StatusCode.Ok ? await resp.data.items : [];
    } 

    const obtenerEsMutuoRecaudable = async (mutuoId: number): Promise<boolean | void> => {
        const resp = await getEsMutuoRecaudable(mutuoId);
        return resp.status === StatusCode.Ok ? resp.data.esMutuoRecaudable : undefined;
    }

    return { obtenerMutuoRecaudar, recaudarDividendo, obtenerRecaudadores, recalcularMontos, obtenerParametroByCodigo, 
        obtenerFormasPago, contablizarOperacion,
        obtenerMutuoDeshacerRecaudacion, obtenerEsMutuoRecaudable, deshacerRecaudacionDividendo };

}

